import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import useQueryLinkNavigate from '../hooks/useQueryLinkNavigate';
import useModalStore from '../zustand/store/useModalStore';
import { useShallow } from 'zustand/shallow';
import { useMenuStore } from '../zustand/store/useMenuStore';

const AuthGuard = ({children}) => {

    const navigate = useNavigate();
    const { pathname, basePath, pathInfo, isHome } = useQueryLinkNavigate();
    const { emogcode } = useParams();
    
    const useremcd = localStorage.getItem('useremcd');
    const userAuth = localStorage.getItem('userAuth');
    const admin = userAuth === 'J001' || userAuth === 'J002';
    
    const showNotiModal = useModalStore(state => state.showNotiModal);

    // 메뉴 관련
    const [isLoaded, fetchMenus, syncMenu, rawMenuList, favMenuData, permissionsData] = useMenuStore(useShallow(
        (state) => [state.isLoaded, state.fetchMenus, state.syncMenu, state.rawMenuList, state.favMenuData, state.permissionsData]));
    
    useEffect(() => {
        fetchMenus();
        favMenuData();
    }, []);
    
    useEffect(() => {
        permissionsData(basePath);
    }, [basePath]);

    // 메뉴 목록에 없는 주소. 화면을 그리기 전에 막는다(그리면 그 화면의 진입 팝업 · 조회가 안내보다 먼저 돈다)
    const noAccess = isLoaded && !isHome && !rawMenuList.find((item) => item.MENUSORC === basePath);

    useEffect(() => {
        if (isLoaded) {
            // [CASE 1] 아예 권한이 없는 URL 접근 시. 메뉴 목록을 새로 받아 권한이 빠진 경우도 같은 안내를 한다
            if (noAccess) {
                showNotiModal('해당하는 페이지의 접근권한이 없습니다.\n담당자에게 문의해주세요.');
                navigate('/', { replace: true });
                return;
            };
            // [CASE 2] 관리자가 아닐 경우 참여기관 정보 진입 시(Agent 관리)
            if(basePath === '/org_mng/org_participate.do') {
                if(!admin) {
                    if(!emogcode) {
                        navigate(`${basePath}/${useremcd}`, { replace: true });
                    } else if (emogcode && emogcode !== useremcd) {
                        showNotiModal('해당하는 페이지의 접근권한이 없습니다.\n담당자에게 문의해주세요.');
                        navigate('/', { replace: true });
                        return;
                    }
                };
            };
             // [CASE 3] /write, /edit, /reply 등 잘못된 경로 접근 시(게시판)
            if (['/write', '/edit', '/reply'].some(path => pathname.includes(path)) && !pathInfo?.clickedMenu) {
                // 메인 게시판 경로로 이동
                showNotiModal('잘못된 접근입니다.\n담당자에게 문의해주세요.');
                navigate(`${basePath}`, { replace: true });
                return;
            };
        };
        // [CASE 4] 정상 접근
        syncMenu(pathname, basePath, emogcode);

    }, [pathname, isLoaded, noAccess]);

    if (!isLoaded || noAccess) return null;

    return children;
}

export default AuthGuard;